if (!customElements.get('blog-post-slider')) {
  customElements.define(
    'blog-post-slider',
    class BlogPostSlider extends HTMLElement {
      constructor() {
        super();

        this.cardSpacing = 80;
        this.perPage = 3;

        this.mobileWidth = 650;
        this.initPosition = 0;

        this.carousel = this.querySelector('.blog-post-slider-carousel');
        // this.cards = this.carousel.querySelectorAll('.blog-post-slider--card');
        this.buttons = this.querySelectorAll('button');

        this.originalCardAmount = this.cards.length;

        let style = getComputedStyle(this.carousel);
        let spacingProperty = style.getPropertyValue('--slider-gap');
        this.cardSpacing = parseInt(spacingProperty);

        this.scrollTicking = false;
        this.index = 1;
        this.scrollIndex = 0;

        this.buttons.forEach((button) => {
          button.classList.remove('hidden');
          button.addEventListener('click', (e) => {
            e.preventDefault();
            if (this.carousel.classList.contains('sliding-transition')) {
              return;
            }
            let moveBy = button.dataset.move;
            if (moveBy == '-1') {
              this.left();
            } else {
              this.right();
            }
          });
        });
      }
      connectedCallback() {
        this.init();
      }
      get activeCard() {
        return this.carousel.querySelector('.blog-post-slider--card.active');
      }
      get inactiveCard() {
        return this.carousel.querySelector('.blog-post-slider--card:not(.active)');
      }
      get cards() {
        return this.carousel.querySelectorAll('.blog-post-slider--card');
      }
      get cardWidth() {
        let style = getComputedStyle(this.carousel);
        let spacingProperty = style.getPropertyValue('--slider-gap');
        this.cardSpacing = parseInt(spacingProperty);
        return this.cards[0].getBoundingClientRect().width + this.cardSpacing;
      }
      setActiveCard(index) {
        this.cards.forEach((card) => card.classList.remove('active'));

        if (index != null) {
          let card = this.cards[index];
          if (card) {
            card.classList.add('active');
            card.addEventListener('animationend', this.setCarouselMaxHeight.bind(this));
          }
        }
      }
      setCarouselMaxHeight(e) {
        let target = e.target;
        target.removeEventListener('animationend', this.setCarouselMaxHeight);
        if (e.animationName == 'blog-post-grow') {
          this.carousel.style.minHeight = `${target.getBoundingClientRect().height}px`;
          this.carousel.classList.add('slider-first-init');
        }
      }
      init() {
        this.cloneCards();
        let firstCard = this.cards[0];
        firstCard.style.animationDuration = '0s';
        this.carousel.classList.add('slider-init');
        let pseudoWidth = firstCard.getBoundingClientRect().width + this.cardSpacing;
        firstCard.style.animationDuration = '0.5s';

        this.initPosition = pseudoWidth * this.originalCardAmount;

        this.carousel.style.transform = `translateX(-${this.initPosition}px)`;

        this.index = this.originalCardAmount + 1;
        this.scrollIndex = this.originalCardAmount;
        this.setActiveCard(this.index);
        if (window.innerWidth <= this.mobileWidth) {
          this.carousel.classList.add('slider-first-init');
        }
      }
      destroy() {
        this.carousel.classList.remove('slider-init');
        this.removeCloneCards();
        this.setActiveCard(null);
      }
      removeCloneCards() {
        let clonedCards = this.querySelectorAll('cloned');
        clonedCards.forEach((card) => {
          card.remove();
        });
      }
      cloneCards() {
        this.cards.forEach((card) => {
          let clonedCard = card.cloneNode(true);
          clonedCard.classList.add('cloned');
          this.carousel.append(clonedCard);
        });

        let cardsReverse = [...this.cards].toReversed();

        cardsReverse.forEach((card) => {
          let clonedCard = card.cloneNode(true);
          clonedCard.classList.add('cloned');
          this.carousel.prepend(clonedCard);
        });
      }
      left() {
        this.carousel.classList.add('sliding-transition');

        let lastCard = this.cards[this.cards.length - 1];
        this.carousel.style.transform = `translateX(-${this.initPosition - this.cardWidth}px)`;
        this.setActiveCard(null);

        setTimeout(() => {
          this.setActiveCard(this.originalCardAmount);
        }, 100);

        setTimeout(() => {
          let clonedCard = lastCard.cloneNode(true);
          this.carousel.prepend(clonedCard);
          lastCard.remove();
          //cancel animations
          let animations = clonedCard.getAnimations();
          animations.forEach((animation) => animation.finish());
          this.carousel.classList.remove('sliding-transition');
          this.carousel.style.transform = `translateX(-${this.initPosition}px)`;
        }, 500);
      }

      right() {
        this.carousel.classList.add('sliding-transition');
        let firstCard = this.cards[0];

        this.carousel.style.transform = `translateX(-${this.initPosition + this.cardWidth}px)`;
        this.setActiveCard(null);

        setTimeout(() => {
          this.setActiveCard(this.originalCardAmount + 2);
        }, 100);

        setTimeout(() => {
          this.carousel.appendChild(firstCard);

          this.carousel.classList.remove('sliding-transition');
          this.carousel.style.transform = `translateX(-${this.initPosition}px)`;
        }, 500);
      }
    }
  );
}
